<template>
  <div class="container-fluid p-0">
    <div class="w-100 general-header">
        <p class="text-center pt-1 pb-1 m-0">{{title}}</p>
    </div>
    <form class="w-100 form-general" v-on:submit.prevent>
        <ContainerUploadDoc
        v-for="(input, index) in inputList" :key="index"
        v-bind:id="index"
        v-bind:name="input.name"
        v-bind:reference="input.reference"
        v-bind:eventType="input.eventType"
        >
        </ContainerUploadDoc>
        <div class="form-group mt-4">
            <button type="submit" class="btn-general" v-on:click="uploadDocs">
                Registrar
            </button>
        </div>
     </form>
    <confirmModal v-if="modalVisible" :message= mensaje></confirmModal>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import {setData, updateAction,uploadDoc} from '@/services/api'
import ContainerUploadDoc from '@/components/containerViews/ContainerUploadDoc'
import { autoLevante } from '@/services/automatedActions'
import confirmModal from '@/components/confirmModal'

export default {
    name: 'UploadDocs',
    components: {
        ContainerUploadDoc,
        confirmModal
    },
    props: {
        type: String,
    },
    data() {
        return {
           title: '',
           inputList: [],
           modalVisible: false,
           mensaje: '',
        }
    },
     computed: {
    ...mapGetters("container",{
      container_id: 'container_id',
      documents: 'documents',
      actions: 'action_list'
    }),
  },
  mounted () {
   // this.$store.commit('set_view_name', [this.container_id])
    this.setType()
  },
  methods: {
    setType: function () {
        switch (this.type) {
            case 'cargador':
                this.title = 'Documentación de expediente'
                this.mensaje = 'Documentación de expediente guardada correctamente.'
                this.inputList.push({name : 'Factura comercial',eventType: 'factura_comercial', reference: 'facturaComercial'})
                this.inputList.push({name : 'Packing list', eventType: 'packing_list',reference: 'packingList'})
                break;
            case 'transportista':
                this.title = 'Pesado'
                this.inputList.push({name : 'VGM',eventType: 'VGM', reference: 'VGM'})
                break;
            case 'transitario':
                this.title = 'Despachar mercancía ante aduana'
                this.mensaje = 'Dua solicitud realizada con éxito'
                this.eventType = 'DUA SOLICITUD'
                this.inputList.push({name : 'DUA Solicitud', eventType: 'DUA_solicitud', reference: 'DUA Solicitud'})
                //this.inputList.push({name : 'Certificado', reference: 'certificado'})
                //this.inputList.push({name : 'Ficha técnica', reference: 'fichaTecnica'})
                break;
            case 'transitarioDanger':
                this.title = 'Solicitar permiso de mercancía peligrosa'
                this.inputList.push({name : 'DUA',  eventType: 'DUA', reference: 'DUA'})
                break;
            case 'transitarioBill':
                this.title = 'Registrar Bill of Lading'
                this.inputList.push({name : 'Bill of Lading',  eventType: 'bill_of_lading', reference: 'billOfLading'})
                this.mensaje = 'Bill of Lading registrado con éxito'
                break;
            default:
                break;
        }
    },
    uploadDocs: function () {
        this.documents.forEach(document => {
            var event = {
                name: this.container_id + '_' +document.eventType,
                eventGroup: 'Group 1',
                eventType: document.eventType,
                expediente: this.container_id,
            }
     
            setData('events/', event).then(res => {
                uploadDoc('events/'+ event.name + '/documents',document.file,document.name).then(res => {

                })
             })
        });
        var now = new Date();
        switch (this.type) {
            case 'cargador':
                updateAction( this.container_id, "DOCUMENTACION_DE_EXPEDIENTE", now, this.actions.stage3.action_list.action009.apiId)
                updateAction( this.container_id, "DUA_SOLICITUD", "pending", '')
                //updateAction( this.container_id, "AUTORIZACIÓN M. PELIGROSA", "pending", '')
                break;
            case 'transportista':
                break;
            case 'transitario':
                updateAction( this.container_id, "DUA_SOLICITUD", now, this.actions.stage3.action_list.action016.apiId)
                updateAction( this.container_id, "AUTORIZACION_LEVANTE", 'pending', '')
                // Simulate next action
                autoLevante(this.container_id)
                break;
            case 'transitarioDanger':
                break;
            case 'transitarioBill':
                updateAction( this.container_id, "REGISTRO_BILL_OF_LADING", now, this.actions.stage4.action_list.action019.apiId)
            default:
                break;
        }
        this.modalVisible = true
        
        // upload(url, this.container_id,this.documents).then(res => {

        // })
    }
  }
}
</script>

<style lang= "scss"  scoped>


</style>
